var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApproved = function SvgApproved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33BDA9",
    d: "m21.21 7.71-8 8c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-4-4A.996.996 0 1 1 9.2 10.3l3.29 3.29 7.29-7.29a.996.996 0 1 1 1.41 1.41h.02Zm-1.1 6.75A7.998 7.998 0 0 1 4.5 12c0-4.42 3.58-8 8-8 1.15 0 2.25.25 3.24.69l1.5-1.5A9.946 9.946 0 0 0 12.5 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 9.96-4.44 10-9.93l-2.39 2.39Z"
  })));
};
export default SvgApproved;